// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__UFC4T"};